import {StoreCreator} from "../../typings";

export function defineStoreCreator(option: StoreCreator): () => StoreCreator {
    return () => option;
}
